"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSimpleTableColumnSelector = void 0;
const react_1 = require("react");
const utils_1 = require("./utils");
/**
 * @category hook
 *
 * @description
 * This is an optional hook for ColumnSelector and returns the required props for all ColumnSelector coponents including an columns array: IColumnListItem[].
 * The columns array has to be converted in order to work with TableSimple. An example of usage exist in the ColumnSelectorButton component.
 *@callback
 The useColumnSelector hook has an optinal callback function that trigger on onChange of checkboxes and onDrag of list items including the event triggered.
 */
const useSimpleTableColumnSelector = ({ columns, columnsTitles, onChange, defaultColumns, props, }) => {
    //ColumnSelectorPopover
    const [searchTerm, setSearchTerm] = (0, react_1.useState)("");
    //ColumnSelectorButton
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const [open, setOpen] = (0, react_1.useState)(false);
    const [selectorItems, setSelectorItems] = (0, react_1.useState)(
    //Initialize with a mapping of all the columns important for subsequent updates
    columns?.map((col) => ({
        columnId: col?.columnId,
        label: columnsTitles[col?.columnId],
        checked: !col.hidden,
    })));
    const handleColumnChange = (e, items) => {
        const visibleColumns = items?.filter((item) => item.checked)?.map(({ columnId }) => columnId);
        const newItems = (0, utils_1.sortColumnSelectorItems)(items, visibleColumns);
        setSelectorItems(newItems);
        //Optional callback that returns the onDrag & onChange event
        onChange && onChange(e, newItems);
    };
    const handleOpenPopover = (bool) => {
        setSearchTerm("");
        setOpen(bool);
    };
    return {
        title: props?.title,
        columns: selectorItems,
        ColumnListProps: {
            items: selectorItems,
            onChange: handleColumnChange,
            EmptyStateProps: props?.EmptyStateProps,
        },
        searchTerm,
        ColumnSearchProps: { placeholder: props?.placeholder },
        buttonResetText: props?.buttonResetText,
        ButtonResetProps: {
            onClick: (e) => handleColumnChange(e, (defaultColumns || columns)?.map((col) => ({
                columnId: col.columnId,
                label: columnsTitles[col?.columnId],
                checked: !col.hidden,
            }))),
        },
        setSearchTerm,
        setAnchorEl,
        anchorEl,
        handleOpenPopover,
        open,
    };
};
exports.useSimpleTableColumnSelector = useSimpleTableColumnSelector;
